module.exports = __webpack_public_path__ + "static/media/c_2.e1a61383.png";